var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"text-center"},[_c('v-progress-circular',{staticClass:"ma-12",style:({ margin: _vm.size > 30 ? '48px' : '5px !important' }),attrs:{"size":_vm.size,"width":_vm.size / 10,"color":"primary","indeterminate":""}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }